var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "editorial_course_wrap",
      attrs: {
        "element-loading-text": "拼命加载中",
        "element-loading-spinner": "el-icon-loading"
      }
    },
    [
      !_vm.isSetMenu
        ? _c(
            "div",
            { staticStyle: { width: "100%", height: "100%" } },
            [
              _c("div", { staticClass: "editorial_course_title" }, [
                _c("p", { staticClass: "goback", on: { click: _vm.goback } }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../../static/images/course/icon-3.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("返回")])
                ]),
                _vm._v(" "),
                _c("h2", [_vm._v(_vm._s(_vm.courseName))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "edit_and_preview" },
                  [
                    !_vm.isEditCourse
                      ? _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                return _vm.setMenu(true)
                              }
                            }
                          },
                          [_vm._v("设置")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isEditCourse
                      ? _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.isEditCourse = true
                              }
                            }
                          },
                          [_vm._v("编辑基本信息")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isEditCourse
                      ? _c(
                          "el-button",
                          {
                            on: {
                              click: function($event) {
                                _vm.isEditCourse = false
                              }
                            }
                          },
                          [_vm._v("取消")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isEditCourse
                      ? _c("el-button", { on: { click: _vm.saveCourseInfo } }, [
                          _vm._v("保存")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isEditCourse
                      ? _c("el-button", { on: { click: _vm.previewCourse } }, [
                          _vm._v("预览")
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              !_vm.isEditCourse
                ? _c("div", { staticClass: "course_info" }, [
                    _c("div", { staticClass: "course_tree" }, [
                      _c("div", { staticClass: "course_chapters" }, [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("../../../../static/images/course/icon-1.png"),
                            alt: ""
                          }
                        }),
                        _vm._v(" "),
                        _c("h3", [_vm._v("目录")]),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "add_course_btn",
                          attrs: {
                            src: require("../../../../static/images/course/icon-2.png"),
                            alt: ""
                          },
                          on: { click: _vm.addCatalog }
                        })
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "course_CTreeCtrl",
                          style: "height:" + (_vm.windowHeight - 230) + "px"
                        },
                        [
                          _c("el-tree", {
                            ref: "tree",
                            attrs: {
                              data: _vm.treeData,
                              props: _vm.defaultProps,
                              "empty-text": "暂无目录",
                              "node-key": "id",
                              "default-expanded-keys": _vm.defaultExpansion,
                              "default-expand-all": false,
                              "highlight-current": true,
                              "expand-on-click-node": false,
                              draggable: _vm.isdraggable
                            },
                            on: {
                              "node-click": _vm.handleNodeClick,
                              "node-drag-start": _vm.handleDragStart,
                              "node-drag-enter": _vm.handleDragEnter,
                              "node-drag-leave": _vm.handleDragLeave,
                              "node-drag-over": _vm.handleDragOver,
                              "node-drag-end": _vm.handleDragEnd,
                              "node-drop": _vm.handleDrop
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var node = ref.node
                                    var data = ref.data
                                    return _c(
                                      "p",
                                      {
                                        staticClass: "custom-tree-node",
                                        staticStyle: {
                                          display: "flex",
                                          "align-items": "center",
                                          "justify-content": "space-between",
                                          "padding-right": "8px",
                                          height: "100%"
                                        },
                                        attrs: { title: node.label }
                                      },
                                      [
                                        data.status && data.status == 1
                                          ? _c("el-input", {
                                              ref: "catalog" + data.id,
                                              staticClass: "nodeInput",
                                              attrs: {
                                                maxlength: "30",
                                                size: "small"
                                              },
                                              on: {
                                                blur: function($event) {
                                                  return _vm.editCatalogSave(
                                                    data,
                                                    node
                                                  )
                                                }
                                              },
                                              nativeOn: {
                                                keyup: function($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.enterInput($event)
                                                },
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              },
                                              model: {
                                                value: data.catalogName,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    data,
                                                    "catalogName",
                                                    typeof $$v === "string"
                                                      ? $$v.trim()
                                                      : $$v
                                                  )
                                                },
                                                expression: "data.catalogName"
                                              }
                                            })
                                          : _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  height: "32px",
                                                  "line-height": "32px"
                                                }
                                              },
                                              [_vm._v(_vm._s(node.label))]
                                            ),
                                        _vm._v(" "),
                                        data.status != 1
                                          ? _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "course_catalog_operation"
                                              },
                                              [
                                                _vm.productFlag != 7
                                                  ? _c("i", {
                                                      staticClass:
                                                        "el-icon-plus",
                                                      attrs: { title: "添加" },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return function() {
                                                            return _vm.appendCatalog(
                                                              data,
                                                              node
                                                            )
                                                          }.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "el-icon-edit-outline",
                                                  attrs: { title: "修改" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.editCatalog(
                                                        node,
                                                        data
                                                      )
                                                    }
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass: "el-icon-delete",
                                                  attrs: { title: "删除" },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return function() {
                                                        return _vm.removeCatalogFn(
                                                          node,
                                                          data
                                                        )
                                                      }.apply(null, arguments)
                                                    }
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              2089315863
                            )
                          })
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "editorial_course_content" }, [
                      _c("div", { staticClass: "cc_title" }, [
                        _vm.isTreeNodeClick
                          ? _c("h2", [
                              _c("img", {
                                attrs: {
                                  src: require("../../../../static/images/course/icon-4.png"),
                                  alt: ""
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    height: "24px",
                                    "line-height": "24px"
                                  },
                                  attrs: { title: _vm.catalogInfo.name }
                                },
                                [_vm._v(_vm._s(_vm.catalogInfo.name))]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isTreeNodeClick
                          ? _c("div", { staticClass: "operation_btn" }, [
                              _vm.isBlock && _vm.relatedMaterialData.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "operation_btn_left" },
                                    [
                                      _c(
                                        "el-checkbox",
                                        {
                                          attrs: {
                                            indeterminate:
                                              _vm.isIndeterminateSource
                                          },
                                          on: {
                                            change: function(checked) {
                                              return _vm.handleCheckAllChange(
                                                "all",
                                                checked
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.isSelectAll,
                                            callback: function($$v) {
                                              _vm.isSelectAll = $$v
                                            },
                                            expression: "isSelectAll"
                                          }
                                        },
                                        [_vm._v("全选")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-checkbox",
                                        {
                                          attrs: {
                                            indeterminate:
                                              _vm.isIndeterminateTask,
                                            disabled: _vm.taskIsdisabled
                                          },
                                          on: {
                                            change: function(checked) {
                                              return _vm.handleCheckAllChange(
                                                "task",
                                                checked
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.isSelectAllTask,
                                            callback: function($$v) {
                                              _vm.isSelectAllTask = $$v
                                            },
                                            expression: "isSelectAllTask"
                                          }
                                        },
                                        [_vm._v("全部设为任务")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-checkbox",
                                        {
                                          attrs: {
                                            indeterminate:
                                              _vm.isIndeterminateDown
                                          },
                                          on: {
                                            change: function(checked) {
                                              return _vm.handleCheckAllChange(
                                                "down",
                                                checked
                                              )
                                            }
                                          },
                                          model: {
                                            value: _vm.isSelectAllDown,
                                            callback: function($$v) {
                                              _vm.isSelectAllDown = $$v
                                            },
                                            expression: "isSelectAllDown"
                                          }
                                        },
                                        [_vm._v("全部允许下载")]
                                      )
                                    ],
                                    1
                                  )
                                : _c("div"),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "operation_btn_right" },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.isAddMaterial = true
                                        }
                                      }
                                    },
                                    [_vm._v("添加素材")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.uploadMaterialDrawer } },
                                    [_vm._v("上传素材")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      on: {
                                        click: function($event) {
                                          _vm.addQuestionShow = true
                                        }
                                      }
                                    },
                                    [_vm._v("添加实操题")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.createQuestionBtn } },
                                    [_vm._v("创建实操题")]
                                  ),
                                  _vm._v(" "),
                                  _vm.productFlag == 1
                                    ? _c(
                                        "el-button",
                                        {
                                          on: {
                                            click: function($event) {
                                              return _vm.addTestpaperShow(
                                                _vm.catalogInfo
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("添加测验")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    { on: { click: _vm.batchDelete } },
                                    [_vm._v("删除")]
                                  ),
                                  _vm._v(" "),
                                  _c("el-button", {
                                    class: _vm.isBlock ? "block" : "list",
                                    on: {
                                      click: function($event) {
                                        _vm.isBlock = !_vm.isBlock
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.relatedMaterialData.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "cc_content",
                              style: "height:" + (_vm.windowHeight - 270) + "px"
                            },
                            [
                              !_vm.isBlock
                                ? _c(
                                    "div",
                                    { staticClass: "source_table_title" },
                                    [
                                      _c(
                                        "p",
                                        [
                                          _c("el-checkbox", {
                                            attrs: {
                                              indeterminate:
                                                _vm.isIndeterminateSource
                                            },
                                            on: {
                                              change: function(checked) {
                                                return _vm.handleCheckAllChange(
                                                  "all",
                                                  checked
                                                )
                                              }
                                            },
                                            model: {
                                              value: _vm.isSelectAll,
                                              callback: function($$v) {
                                                _vm.isSelectAll = $$v
                                              },
                                              expression: "isSelectAll"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("p", [_vm._v("序号")]),
                                      _vm._v(" "),
                                      _c("p", [_vm._v("资源标题")]),
                                      _vm._v(" "),
                                      _c("p", [_vm._v("类型")]),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              attrs: {
                                                indeterminate:
                                                  _vm.isIndeterminateTask,
                                                disabled: _vm.taskIsdisabled
                                              },
                                              on: {
                                                change: function(checked) {
                                                  return _vm.handleCheckAllChange(
                                                    "task",
                                                    checked
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.isSelectAllTask,
                                                callback: function($$v) {
                                                  _vm.isSelectAllTask = $$v
                                                },
                                                expression: "isSelectAllTask"
                                              }
                                            },
                                            [_vm._v("设为任务")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              attrs: {
                                                indeterminate:
                                                  _vm.isIndeterminateDown
                                              },
                                              on: {
                                                change: function(checked) {
                                                  return _vm.handleCheckAllChange(
                                                    "down",
                                                    checked
                                                  )
                                                }
                                              },
                                              model: {
                                                value: _vm.isSelectAllDown,
                                                callback: function($$v) {
                                                  _vm.isSelectAllDown = $$v
                                                },
                                                expression: "isSelectAllDown"
                                              }
                                            },
                                            [_vm._v("允许下载")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("p", [_vm._v("操作")])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isBlock
                                ? _c(
                                    "draggable",
                                    {
                                      staticClass: "block",
                                      attrs: { tag: "ul" },
                                      on: { update: _vm.sourceSort },
                                      model: {
                                        value: _vm.relatedMaterialData,
                                        callback: function($$v) {
                                          _vm.relatedMaterialData = $$v
                                        },
                                        expression: "relatedMaterialData"
                                      }
                                    },
                                    _vm._l(_vm.relatedMaterialData, function(
                                      item,
                                      key
                                    ) {
                                      return _c(
                                        "li",
                                        {
                                          key: key,
                                          attrs: { "data-key": item.id }
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              class:
                                                "img_box " +
                                                _vm.imgBg(
                                                  item.resourceType,
                                                  item.type
                                                )
                                            },
                                            [
                                              _c(
                                                "el-checkbox-group",
                                                {
                                                  staticClass: "select_box",
                                                  on: {
                                                    change: function(checked) {
                                                      return _vm.handleCheckedTopicChange(
                                                        "all",
                                                        checked
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.seleceSource,
                                                    callback: function($$v) {
                                                      _vm.seleceSource = $$v
                                                    },
                                                    expression: "seleceSource"
                                                  }
                                                },
                                                [
                                                  _c("el-checkbox", {
                                                    key: item.courseResourceId,
                                                    attrs: {
                                                      label:
                                                        item.courseResourceId
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("img", {
                                                staticClass: "delete_source",
                                                attrs: {
                                                  src: require("../../../../static/images/course/delete.png"),
                                                  alt: ""
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteSource1(
                                                      item
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              item.resourceType == 1 &&
                                              item.type == 1
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/blockIcon/pic.png"),
                                                      alt: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.previewDocument(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 1 &&
                                              item.type == 2
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/blockIcon/file.png"),
                                                      alt: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.previewDocument(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 1 &&
                                              item.type == 3
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/blockIcon/audio.png"),
                                                      alt: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.previewDocument(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 1 &&
                                              item.type == 4
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/blockIcon/video.png"),
                                                      alt: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.previewDocument(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 1 &&
                                              item.type == 5
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/blockIcon/zip.png"),
                                                      alt: ""
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.previewDocument(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 3
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/blockIcon/question.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 5
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/blockIcon/test.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "title_box" },
                                            [
                                              item.resourceType == 1
                                                ? _c(
                                                    "p",
                                                    {
                                                      attrs: {
                                                        title: item.name
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 3
                                                ? _c(
                                                    "p",
                                                    {
                                                      attrs: {
                                                        title: item.name
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.name
                                                            ? item.name
                                                            : "实操题" + item.id
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 5
                                                ? _c(
                                                    "p",
                                                    {
                                                      attrs: {
                                                        title: item.name
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 3 ||
                                              item.resourceType == 5
                                                ? _c("i", {
                                                    staticClass:
                                                      "el-icon-edit-outline",
                                                    attrs: { title: "编辑" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleGoResource(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "isDownload" },
                                            [
                                              (item.resourceType == 3 &&
                                                _vm.productFlag == 7) ||
                                              _vm.productFlag != 7
                                                ? _c(
                                                    "el-checkbox-group",
                                                    {
                                                      on: {
                                                        change: function(
                                                          checked
                                                        ) {
                                                          return _vm.handleCheckedTopicChange(
                                                            "task",
                                                            checked,
                                                            item
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: _vm.seleceTask,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.seleceTask = $$v
                                                        },
                                                        expression: "seleceTask"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "el-checkbox",
                                                        {
                                                          key:
                                                            item.courseResourceId,
                                                          attrs: {
                                                            label:
                                                              item.courseResourceId
                                                          }
                                                        },
                                                        [_vm._v("设为任务")]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 1
                                                ? _c(
                                                    "el-checkbox-group",
                                                    {
                                                      on: {
                                                        change: function(
                                                          checked
                                                        ) {
                                                          return _vm.handleCheckedTopicChange(
                                                            "down",
                                                            checked,
                                                            item
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: _vm.seleceDown,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.seleceDown = $$v
                                                        },
                                                        expression: "seleceDown"
                                                      }
                                                    },
                                                    [
                                                      item.resourceType == 1
                                                        ? _c(
                                                            "el-checkbox",
                                                            {
                                                              key:
                                                                item.courseResourceId,
                                                              attrs: {
                                                                label:
                                                                  item.courseResourceId
                                                              }
                                                            },
                                                            [_vm._v("允许下载")]
                                                          )
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _c(
                                    "draggable",
                                    {
                                      staticClass: "list",
                                      attrs: { tag: "ul" },
                                      on: { update: _vm.sourceSort },
                                      model: {
                                        value: _vm.relatedMaterialData,
                                        callback: function($$v) {
                                          _vm.relatedMaterialData = $$v
                                        },
                                        expression: "relatedMaterialData"
                                      }
                                    },
                                    _vm._l(_vm.relatedMaterialData, function(
                                      item,
                                      key
                                    ) {
                                      return _c(
                                        "li",
                                        {
                                          key: key,
                                          attrs: { "data-key": item.id }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "select_box" },
                                            [
                                              _c(
                                                "el-checkbox-group",
                                                {
                                                  on: {
                                                    change: function(checked) {
                                                      return _vm.handleCheckedTopicChange(
                                                        "all",
                                                        checked
                                                      )
                                                    }
                                                  },
                                                  model: {
                                                    value: _vm.seleceSource,
                                                    callback: function($$v) {
                                                      _vm.seleceSource = $$v
                                                    },
                                                    expression: "seleceSource"
                                                  }
                                                },
                                                [
                                                  _c("el-checkbox", {
                                                    key: item.courseResourceId,
                                                    attrs: {
                                                      label:
                                                        item.courseResourceId
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "index_box" },
                                            [_vm._v(_vm._s(key + 1))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "title_box" },
                                            [
                                              item.resourceType == 1
                                                ? _c(
                                                    "p",
                                                    {
                                                      attrs: {
                                                        title: item.name
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 3
                                                ? _c(
                                                    "p",
                                                    {
                                                      attrs: {
                                                        title: item.name
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.name
                                                            ? item.name
                                                            : "实操题" + item.id
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 5
                                                ? _c(
                                                    "p",
                                                    {
                                                      attrs: {
                                                        title: item.name
                                                      }
                                                    },
                                                    [_vm._v(_vm._s(item.name))]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "type_box" },
                                            [
                                              item.resourceType == 1 &&
                                              item.type == 1
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/listIcon/pic.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                : _vm._e(),
                                              item.resourceType == 1 &&
                                              item.type == 1
                                                ? _c("span", [_vm._v("图片")])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 1 &&
                                              item.type == 2
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/listIcon/file.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                : _vm._e(),
                                              item.resourceType == 1 &&
                                              item.type == 2
                                                ? _c("span", [_vm._v("文件")])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 1 &&
                                              item.type == 3
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/listIcon/audio.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                : _vm._e(),
                                              item.resourceType == 1 &&
                                              item.type == 3
                                                ? _c("span", [_vm._v("音频")])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 1 &&
                                              item.type == 4
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/listIcon/video.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                : _vm._e(),
                                              item.resourceType == 1 &&
                                              item.type == 4
                                                ? _c("span", [_vm._v("视频")])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 1 &&
                                              item.type == 5
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/listIcon/zip.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                : _vm._e(),
                                              item.resourceType == 1 &&
                                              item.type == 5
                                                ? _c("span", [_vm._v("zip")])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 3
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/listIcon/question.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                : _vm._e(),
                                              item.resourceType == 3
                                                ? _c("span", [_vm._v("试题")])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 5
                                                ? _c("img", {
                                                    staticClass: "source_icon",
                                                    attrs: {
                                                      src: require("../../../../static/images/course/listIcon/test.png"),
                                                      alt: ""
                                                    }
                                                  })
                                                : _vm._e(),
                                              item.resourceType == 5
                                                ? _c("span", [_vm._v("试卷")])
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "task_box" },
                                            [
                                              (item.resourceType == 3 &&
                                                _vm.productFlag == 7) ||
                                              _vm.productFlag != 7
                                                ? _c(
                                                    "el-checkbox-group",
                                                    {
                                                      on: {
                                                        change: function(
                                                          checked
                                                        ) {
                                                          return _vm.handleCheckedTopicChange(
                                                            "task",
                                                            checked,
                                                            item
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: _vm.seleceTask,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.seleceTask = $$v
                                                        },
                                                        expression: "seleceTask"
                                                      }
                                                    },
                                                    [
                                                      _c("el-checkbox", {
                                                        key:
                                                          item.courseResourceId,
                                                        attrs: {
                                                          label:
                                                            item.courseResourceId
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "down_box" },
                                            [
                                              item.resourceType == 1
                                                ? _c(
                                                    "el-checkbox-group",
                                                    {
                                                      on: {
                                                        change: function(
                                                          checked
                                                        ) {
                                                          return _vm.handleCheckedTopicChange(
                                                            "down",
                                                            checked,
                                                            item
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: _vm.seleceDown,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.seleceDown = $$v
                                                        },
                                                        expression: "seleceDown"
                                                      }
                                                    },
                                                    [
                                                      item.resourceType == 1
                                                        ? _c("el-checkbox", {
                                                            key:
                                                              item.courseResourceId,
                                                            attrs: {
                                                              label:
                                                                item.courseResourceId
                                                            }
                                                          })
                                                        : _vm._e()
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "operation_box" },
                                            [
                                              item.resourceType == 1
                                                ? _c("span", {
                                                    staticClass:
                                                      "preview_source",
                                                    attrs: { title: "预览" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.previewDocument(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              item.resourceType == 3 ||
                                              item.resourceType == 5
                                                ? _c("span", {
                                                    staticClass: "edit_source",
                                                    attrs: { title: "编辑" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.handleGoResource(
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "delete_source",
                                                attrs: { title: "删除" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteSource1(
                                                      item
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              key !=
                                              _vm.relatedMaterialData.length - 1
                                                ? _c("span", {
                                                    staticClass: "down_source",
                                                    attrs: { title: "下移" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.downMove(
                                                          key,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              key != 0
                                                ? _c("span", {
                                                    staticClass: "up_source",
                                                    attrs: { title: "上移" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.upMove(
                                                          key,
                                                          item
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                            ],
                            1
                          )
                        : _c("div", { staticClass: "no_content" }, [
                            _c("img", {
                              attrs: {
                                src: require("../../../../static/images/wujieguo.png"),
                                alt: ""
                              }
                            }),
                            _vm._v(" "),
                            _c("p", [_vm._v("暂无内容")])
                          ])
                    ])
                  ])
                : _c(
                    "div",
                    { staticClass: "edit_info" },
                    [
                      _c("edit-course", {
                        ref: "editInfo",
                        attrs: {
                          editCourseInfoForm: _vm.editCourseInfoForm,
                          imageUrl: _vm.imgUrl,
                          courseId: Number(_vm.courseId)
                        }
                      })
                    ],
                    1
                  ),
              _vm._v(" "),
              _c(
                "el-drawer",
                {
                  attrs: {
                    visible: _vm.isAddMaterial,
                    direction: _vm.direction,
                    size: "80%",
                    "destroy-on-close": "",
                    "with-header": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.isAddMaterial = $event
                    }
                  }
                },
                [
                  _c("addMaterial", {
                    attrs: { subjectId: _vm.editCourseInfoForm.subject },
                    on: { closeAddMaterial: _vm.closeAddMaterial }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-drawer",
                {
                  attrs: {
                    visible: _vm.isUploadMaterial,
                    direction: _vm.direction,
                    size: "80%",
                    "destroy-on-close": "",
                    "with-header": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.isUploadMaterial = $event
                    }
                  }
                },
                [
                  _c("uploadMaterial", {
                    ref: "uploadMaterial",
                    attrs: {
                      subjectId: _vm.editCourseInfoForm.subject,
                      isUploadMaterial: _vm.isUploadMaterial
                    },
                    on: {
                      uploadMaterial: _vm.uploadMaterial,
                      uploadMaterialClick: _vm.uploadMaterialClick
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-drawer",
                {
                  attrs: {
                    visible: _vm.addQuestionShow,
                    direction: _vm.direction,
                    size: "80%",
                    "with-header": false,
                    "close-on-press-escape": false,
                    "before-close": _vm.closeQuestion
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.addQuestionShow = $event
                    }
                  }
                },
                [
                  _c("addQuestion", {
                    ref: "addQuestion",
                    attrs: {
                      addQuestionShow: _vm.addQuestionShow,
                      subject: _vm.editCourseInfoForm.subject
                    },
                    on: {
                      addQuestionSave: _vm.addQuestionSave,
                      cancelQuestion: _vm.closeQuestion
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-drawer",
                {
                  attrs: {
                    visible: _vm.createQuestionShow,
                    direction: _vm.direction,
                    size: "80%",
                    "with-header": false,
                    "close-on-press-escape": false,
                    "before-close": _vm.closeCreateQuestion
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.createQuestionShow = $event
                    }
                  }
                },
                [
                  _c("createQuestion", {
                    ref: "addTestpaper",
                    attrs: { createQuestionShow: _vm.createQuestionShow },
                    on: {
                      closeCreateQuestion: _vm.closeCreateQuestion,
                      saveQuestion: _vm.saveQuestion
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-drawer",
                {
                  attrs: {
                    visible: _vm.dialogResourceVisible,
                    direction: _vm.direction,
                    size: "80%",
                    "with-header": false,
                    "close-on-press-escape": false,
                    "before-close": _vm.viewResourceCancel
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.dialogResourceVisible = $event
                    }
                  }
                },
                [
                  _c("view-resource", {
                    attrs: {
                      resourceVisible: _vm.resourceVisible,
                      resourceUrl: _vm.resourceUrl,
                      posterSrc: _vm.posterSrc,
                      resourceInfo: _vm.resourceInfo
                    },
                    on: {
                      onclickCancel: _vm.viewResourceCancel,
                      oncilckConfirm: _vm.viewResourceConfirm
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c("setCatalog")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-310359f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-310359f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/course/editCourse.vue
// module id = null
// module chunks = 